<template>
  <div class="goods-editor">
    <div class="tip">带“*”号为必填项</div>
    <FormList
      :list="formList"
      :data="formData"
      :onChange="onInputChange"
    />
    <van-row class='btn-wrap'>
      <van-button @click="saveGoods" class="confirm-btn" type="info" color="#4573DE">确 认</van-button>
    </van-row>
  </div>
</template>

<script>
import {
  Button,
  Row,
  Notify
} from 'vant'
import FormList from '@components/FormList'
import { invoiceRequest } from '@services'
import { localStorage, goodNameLengthTest } from '@utils/basicUtil'

import {
  TAX_RATE
} from '@assets/config'

export default {
  data () {
    return {
      formData: {
        taxSign: true
      },
      total: 0
    }
  },
  computed: {
    showTaxSign () {
      // 0 显示
      // 1 不显示。默认所有商品含税
      return localStorage.get('showTaxSign') === '0'
    },
    formList () {
      if (localStorage.get('showTaxSign') === '0') {
        return [
          {
            type: 'text',
            field: 'goodsName',
            label: '商品名称',
            required: true,
            placeholder: '请输入商品名称'
          },
          // 0:'不含税',
          // 1:'含税'
          {
            type: 'switch',
            field: 'taxSign',
            label: '含税标识'
          },
          {
            type: 'number',
            field: 'price',
            label: '单价',
            placeholder: '请输入商品单价'
          },
          {
            type: 'select',
            field: 'taxRate',
            label: '税率',
            required: true,
            placeholder: '请选择商品税率',
            options: TAX_RATE
          },
          {
            type: 'text',
            field: 'specification',
            label: '规格型号',
            placeholder: '请输入规格型号'
          },
          {
            type: 'text',
            field: 'unit',
            label: '计量单位',
            placeholder: '请输入计量单位'
          }
        ]
      } else {
        return [{
          type: 'text',
          field: 'goodsName',
          label: '商品名称',
          required: true,
          placeholder: '请输入商品名称'
        },
        {
          type: 'number',
          field: 'price',
          label: '单价',
          placeholder: '请输入商品单价'
        },
        {
          type: 'text',
          field: 'specification',
          label: '规格型号',
          placeholder: '请输入规格型号'
        },
        {
          type: 'text',
          field: 'unit',
          label: '计量单位',
          placeholder: '请输入计量单位'
        }]
      }
    }
  },
  mounted () {

  },
  methods: {
    saveGoods () {
      const postData = {
        goodsName: this.formData.goodsName,
        price: this.formData.price,
        unit: this.formData.unit,
        taxSign: this.formData.taxSign ? 1 : 0,
        taxRate: this.formData.taxRate,
        specification: this.formData.specification
      }
      this.addGoods(postData)
    },
    onInputChange ({ e, field }) {
      this.formData[field] = e
    },
    async addGoods (postData) {
      if (postData.goodsName === undefined || postData.goodsName.trim().length === 0) {
        return Notify({ type: 'danger', message: '请输入商品名称!' })
      }
      if (!goodNameLengthTest(postData.goodsName)) {
        return
      }
      if (
        this.showTaxSign &&
        (postData.taxRate === undefined ||
        postData.taxRate === null)
      ) {
        return Notify({ type: 'danger', message: '请选择商品税率!' })
      }
      const data = await invoiceRequest.goods.addGoods(postData)
      if (data.success) {
        this.$router.replace('/invoice/goods-list')
        // this.$router.push('/invoice/goods-list')
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  components: {
    FormList,
    [Button.name]: Button,
    [Row.name]: Row

  }
}
</script>

<style lang="less" scoped src="./style.less"/>
